import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fc3d5c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-form-cover" }
const _hoisted_2 = { class: "search_form__container" }
const _hoisted_3 = { class: "search_form__information" }
const _hoisted_4 = { class: "search_form__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_StarInput = _resolveComponent("StarInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Perguntas: " + _toDisplayString(_ctx.currentPage) + "/" + _toDisplayString(_ctx.totalPages), 1)
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.question.question.title), 1),
      _createVNode(_component_TUIViewer, {
        "model-value": _ctx.question.question.description
      }, null, 8, ["model-value"]),
      _createElementVNode("div", {
        class: _normalizeClass(["stars", { 'stars--disabled': _ctx.disabled }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.starValues, (star) => {
          return (_openBlock(), _createBlock(_component_StarInput, {
            key: star,
            id: 'star' + star,
            value: star,
            name: 'rating',
            modelValue: _ctx.stars,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stars) = $event)),
            starWitdh: "55px",
            showNumber: true,
            isActive: star <= _ctx.stars,
            disabled: _ctx.disabled,
            numberLabel: star
          }, null, 8, ["id", "value", "modelValue", "isActive", "disabled", "numberLabel"]))
        }), 128))
      ], 2)
    ])
  ]))
}